const upgrade = [
    {
        path: '/upgrade/firmware',
        name: 'upgradeFirmware',
        component: () => import('@/view/upgrade/firmware'),
    },
    {
        path: '/upgrade/create',
        name: 'upgradeCreate',
        component: () => import('@/view/upgrade/create'),
    },
    {
        path: '/upgrade/record',
        name: 'upgradeRecord',
        component: () => import('@/view/upgrade/record'),
    },


]
export default upgrade